import vendorImg from "../../../assets/images/service/vendor.jpg";
import {
  Settings,
  ShieldCheck,
  FileCheck,
  Briefcase,
  CheckCircle,
  Truck,
  TrendingUp,
  Maximize,
  UserCheck,
  Handshake,
  Workflow
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function MNCVendorServices() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Strategic <span className="green">MNC Vendor Partner</span> & Service Provider
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise serves as a registered vendor for top-tier MNCs, 
                    delivering high-quality goods and end-to-end technical services 
                    under rigorous Annual Rate Contracts (ARC).
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Authorized vendor for Reliance BP Mobility Ltd. & others</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Integrated supply chain & service delivery model</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Unmatched compliance with global safety standards</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={vendorImg}
                      alt="MNC Vendor Services"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-certificate"></i> Verified MNC Partner
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">About the Service</h3>
                    <p className="mb-3">
                      At Denial Enterprise, we understand that working with multinational corporations requires more than just delivery—it requires a commitment to excellence, transparent procurement, and rapid response times. We provide a hybrid model of "Goods + Services," ensuring that infrastructure components and technical maintenance are handled by a single, accountable entity.
                    </p>
                    <p className="mb-3">
                      Our systems are designed to integrate with corporate procurement portals, providing real-time tracking of Purchase Orders (PO) and seamless Tally-integrated invoicing to ensure zero friction in the supply chain.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Handshake size={22} />
                        </span>
                        <span>ARC Management & Contractual Compliance</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Workflow size={22} />
                        </span>
                        <span>End-to-End Procurement & Technical Execution</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Truck size={22} />
                        </span>
                        <span>Just-in-Time Delivery & Logistical Support</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Adherence to Corporate HSSE & Quality Protocols</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">Why MNCs Trust Us</h4>
                    <p className="mb-6">
                      Partnering with Denial Enterprise means gaining a vendor that scales with your growth. We manage the volatility of raw material costs and regulatory changes so your operations remain uninterrupted.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <CheckCircle size={22} />
                        </span>
                        <span>100% adherence to technical specifications</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Settings size={22} />
                        </span>
                        <span>Transparent pricing and cost-efficiency models</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Briefcase size={22} />
                        </span>
                        <span>Dedicated account management for corporate clients</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Proactive risk mitigation in supply chain</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Scalable service capacity for nationwide deployment</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Proven track record with Fortune 500 partners</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}